<app-flow-file-uploader
  #Uploader
  [configuration]="flowFileUploaderConfiguration"
  (onFlowFilesUpdate)="updateFlowList($event)">
</app-flow-file-uploader>
